import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchTiposPublicacionAdm, setTiposPublicacion } from '../../../actions/tiposPublicacionActions';
import { fetchTiposPublicacion } from '../../../actions/publicacionesActions';
import { setObject } from '../../../actions/generalActios';
import ReactPaginate from 'react-paginate';
import GoBackArrow from '../../General/GoBackArrow';
import { Spinner } from 'react-bootstrap';
import { withNavigation } from '../../General/withNavigation';
import { editSeller } from '../../../actions/sellersActions';

// Wrapper para usar hooks en class component
function SelectTipoPublicacionesWrapper(props) {
    const navigate = useNavigate();
    return <SelectTipoPublicaciones {...props} navigate={navigate} />;
}

class SelectTipoPublicaciones extends React.Component {
    constructor() {
        super();
        this.state = {
            didEdit: false,
            checked: 0,
            listaIdTiposPublicaciones: [],
            pageSize: 10,
            page: 1
        }
    }

    componentDidMount() {
        // this.props.fetchTiposPublicacion(this.props.seller.codigo);
        this.busquedaTiposPublicacion();
    }

    //busquedaTiposPublicacion = (numPagina) => {
    //    this.props.fetchTiposPublicacionAdm({
    //        idSeller: null,
    //        Page: numPagina ?? 1,
    //        PageSize: 10,
    //    });
    //    this.comprobarCheckbox();
    //}

    busquedaTiposPublicacion = async (numPagina) => {
        await this.props.fetchTiposPublicacionAdm({
            idSeller: null,
            Page: numPagina ?? 1,
            PageSize: 10,
        });

        this.comprobarCheckbox();
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ page: selectedPage });
        this.busquedaTiposPublicacion(selectedPage);
    }

    changeCheck = (params) => {
        this.addToAsociarSeller(params);
    }

    clickFila = (params) => {
        this.addToAsociarSeller(params);
    }

    addToAsociarSeller = (params) => {
        let arrayEstado = [];
        arrayEstado = this.state.listaIdTiposPublicaciones;
        let repetido = arrayEstado.some(item => item.codigo == params.codigo);

        if (repetido) {
            let index = arrayEstado.findIndex(x => x.codigo == params.codigo);
            if (index !== undefined) {
                arrayEstado.splice(index, 1);
                this.setState({ listaIdTiposPublicaciones: arrayEstado });
                this.props.setTiposPublicacion(arrayEstado);
                document.getElementById("check" + params.codigo).checked = false;
            }
        }
        else {
            arrayEstado.push(params);
            this.setState({ listaIdTiposPublicaciones: arrayEstado });
            this.props.setTiposPublicacion(arrayEstado);
            document.getElementById("check" + params.codigo).checked = true;
        }
    }

    comprobarCheckbox = () => {
        let planChecked = [];
        let plan = [];
        let idsIniciales = [];

        if (JSON.stringify(this.props.settedTiposPublicacion) != "{}") {
            setTimeout(() => {
                for (let i = 0; i < this.props.settedTiposPublicacion.length; i++) {
                    planChecked.push("check" + this.props.settedTiposPublicacion[i].codigo);
                    idsIniciales.push(this.props.settedTiposPublicacion[i]);
                }
                this.setState({
                    listaIdTiposPublicaciones: idsIniciales
                });
                var inputs = document.getElementsByName('checkBoxes');
                for (let i = 0; i < inputs.length; i++) {
                    let element = inputs[i].id;
                    plan.push(element);
                }
                for (let i = 0; i < plan.length; i++) {
                    document.getElementById(plan[i]).checked = false;
                }
                for (let i = 0; i < planChecked.length; i++) {
                    for (let c = 0; c < plan.length; c++) {
                        if (plan[c] == planChecked[i]) {
                            document.getElementById(plan[c]).checked = true;
                        }
                    }
                }
            }, 500)
        } else {
            setTimeout(() => {
                for (let i = 0; i < this.props.tiposPublicacionesAsignados.length; i++) {
                    planChecked.push("check" + this.props.tiposPublicacionesAsignados[i].codigo);
                    idsIniciales.push(this.props.tiposPublicacionesAsignados[i]);
                }
                this.setState({
                    listaIdTiposPublicaciones: idsIniciales
                });
                var inputs = document.getElementsByName('checkBoxes');
                for (let i = 0; i < inputs.length; i++) {
                    let element = inputs[i].id;
                    plan.push(element);
                }
                for (let i = 0; i < plan.length; i++) {
                    document.getElementById(plan[i]).checked = false;
                }
                for (let i = 0; i < planChecked.length; i++) {
                    for (let c = 0; c < plan.length; c++) {
                        if (plan[c] == planChecked[i]) {
                            document.getElementById(plan[c]).checked = true;
                        }
                    }
                }
            }, 500)
        }

    }

    agregarTiposASeller = () => {
        this.props.setObject(this.props.seller);

        if (this.props.editando) {
            this.props.navigate(`/Sellers/Editar/Select/${this.props.seller.codigo}`, { state: 2 });
        } else {
            this.props.navigate("/Sellers/Nuevo/Select", { state: 2 });
        }
    }

    onSelect = (tipoPublicacion) => {
        this.props.navigate({
            pathname: "/Publicaciones/Nueva",
            state: {
                pathReturn: this.props.location.pathname,
                tipoPublicacion: tipoPublicacion
            }
        });
    }

    onBack = () => {
        this.props.navigate({
            pathname: "/Sellers",
            state: { pathReturn: this.props.location.pathname }
        });
    }


    render() {
        let elements = null;
        if (this.props.tiposPublicaciones != undefined) {
            elements = this.props.tiposPublicaciones
                .filter(item => item.estado === 0)
                .map((item, i) => {
                    return (
                        <tr key={i} onClick={() => this.clickFila(item)} className="hover-background-color">
                            <td>{item.descripcion}</td>
                            <td><i className="font-size-072rem fas fa-percent" /> {item.comision}</td>
                            <td>
                                <div className="custom-control custom-checkbox">
                                    <input
                                        onClick={() => this.clickFila(item)}
                                        name="checkBoxes"
                                        onChange={() => this.changeCheck(item)}
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={"check" + item.codigo}
                                    >
                                    </input>
                                    <label className="custom-control-label" htmlFor={"check" + item.codigo}></label>
                                </div>
                            </td>
                        </tr>
                    )
                });
        }


        return (
            <div className="container">
                <div className="row justify-content-between align-items-center">

                    <div className="col-auto mb-3">
                        <GoBackArrow />
                    </div>

                    <div className="col-auto text-end mb-3">
                        <button
                            onClick={() => this.agregarTiposASeller()}
                            className="btn btn-sm background-rojo-megatone waves-light"
                        >
                            Agregar/Quitar
                        </button>
                    </div>

                    <div hidden={!this.props.loadingTipoPublicaciones}>
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        </div>
                    </div>

                    <div
                        className="list-group-item col-12 animated fadeIn"
                        hidden={this.props.loadingTipoPublicaciones}
                    >
                        <div className="table-responsive card">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Tipo publicación</th>
                                        <th scope="col">Comisión</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        elements
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center">

                        <ReactPaginate
                            previousLabel={"Anterior"}
                            nextLabel={"Siguiente"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={Math.ceil(this.props.cantidadTotal / this.state.pageSize)}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.state.page - 1}
                        />
                    </div>

                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    seller: state.sellers.seller,
    editando: state.general.editando,
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    loadingTipoPublicaciones: state.tiposPublicacion.loadingTiposPublicacion,
    tiposPublicaciones: state.tiposPublicacion.tiposPublicaciones.elementos,
    tiposPublicacionesAsignados: state.publicaciones.tiposPublicacion,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    // cantidadTotal: state.tiposPublicacion.tiposPublicaciones.cantidadTotal,
    // cantidadPagina: state.tiposPublicacion.tiposPublicaciones.cantidadPagina

    cantidadTotal: state.tiposPublicacion.tiposPublicaciones.total,
    numeroPagina: state.tiposPublicacion.tiposPublicaciones.page,
});

export default withNavigation(connect(mapStateToProps, {
    fetchTiposPublicacionAdm,
    fetchTiposPublicacion,
    setTiposPublicacion,
    setObject,
    editSeller,
})(SelectTipoPublicacionesWrapper));